// extracted by mini-css-extract-plugin
export var calendarView = "_65-0";